var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-full flex items-center justify-center bg-lightPurple py-3 space-x-2"},[_vm._t("default"),_c('span',{staticClass:"text-white font-bold text-sm uppercase "},[_vm._v(_vm._s(_vm.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }